import { render, staticRenderFns } from "./ResourceRelatedPopup.vue?vue&type=template&id=99e19e4e&scoped=true"
import script from "./ResourceRelatedPopup.vue?vue&type=script&lang=js"
export * from "./ResourceRelatedPopup.vue?vue&type=script&lang=js"
import style0 from "./ResourceRelatedPopup.vue?vue&type=style&index=0&id=99e19e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e19e4e",
  null
  
)

export default component.exports